<div class="filter-popup-container">
    <div class="filter-popup-header">
        <h2>Filtros de Territorios</h2>
    </div>

    <div class="filter-popup-content">
        <div class="filter-section">
            <label class="filter-label">Región</label>
            <div class="region-selector" [class.selected]="selectedFilters.Region?.description.length > 0" (click)="toggleRegionDropdown()">
                <span class="select-value">{{ selectedFilters.Region.description || 'Seleccionar región' }}</span>
                <mat-icon class="select-arrow" [class.rotated]="isRegionDropdownOpen">expand_more</mat-icon>
            </div>
            <div class="region-options-list" *ngIf="isRegionDropdownOpen">
                <div class="dropdown-option" (click)="selectRegion({ description: '', idRegion: '' })">---</div>
                <div class="dropdown-option" *ngFor="let region of filterData.Regiones" [class.selected]="selectedFilters.Region.description === region.description" (click)="selectRegion(region)">
                    {{ region.description }}
                </div>
            </div>
        </div>

        <div class="filter-section">
            <label class="filter-label">Zona</label>
            <div class="chip-group">
                <span class="filter-chip" *ngFor="let zona of zonesByIdRegion" [class.selected]="selectedFilters.Zona.description === zona.description" (click)="selectZona(zona)">
                    {{ zona.description }}
                </span>
                <span *ngIf="zonesByIdRegion.length === 0">Selecciona una región con zonas disponibles</span>
            </div>
        </div>

        <div class="filter-section">
            <label class="filter-label">Tipo de Ruta</label>
            <div class="chip-group">
                <span class="filter-chip" *ngFor="let tipo of filterData.TipoRuta" [class.selected]="selectedFilters.TipoRuta.includes(tipo)" (click)="selectTipoRuta(tipo)">
                    {{ territoryRouteTypeAcronymDisplayEnum[tipo] || tipo }}
                </span>
            </div>
        </div>

        <div class="filter-section" *ngIf="this.isRouteTypeSelected">
            <label *ngIf="DiaVisitaFilteredByRouteType.length > 0" class="filter-label">Día de Visita</label>
            <label *ngIf="DiaVisitaFilteredByRouteType.length == 0" class="filter-label">No hay días disponibles</label>
            <div class="days-group">
                <div class="day-option" *ngFor="let dia of DiaVisitaFilteredByRouteType" [class.selected]="selectedFilters.DiaVisita.includes(dia)" (click)="toggleDiaVisita(dia)">
                    {{ dia }}
                </div>
            </div>
        </div>

        <div class="filter-section" *ngIf="this.isRouteTypeSelected ">
            <label *ngIf="FrecuenciaRutaFilteredByRouteType.length > 0" class="filter-label">Frecuencia de Ruta</label>
            <label *ngIf="FrecuenciaRutaFilteredByRouteType.length == 0" class="filter-label">No hay frecuencias disponibles</label>
            <div class="frequency-group">
                <div class="frequency-option" *ngFor="let frec of FrecuenciaRutaFilteredByRouteType" [class.selected]="selectedFilters.FrecuenciaRuta.includes(frec)" (click)="toggleFrecuencia(frec)">
                    {{ frec }}
                </div>
            </div>
        </div>
    </div>

    <div class="filter-popup-actions">
        <button class="btnClose" (click)="onClose()">Regresar</button>
        <button class="btn-clear" (click)="onClear()">Limpiar</button>
        <button class="btn-search" (click)="onSearch()">Buscar</button>
    </div>
</div>
